import { createContext } from "react";

import { useRequiredContext } from "~/tools/use-required-context";

export type ToggleListLocation = "trigger" | "content";

const ToggleListLocationContext = createContext<null | ToggleListLocation>("trigger");

export const ToggleListLocationContextProvider = ToggleListLocationContext.Provider;

export const useToggleListLocation = (): ToggleListLocation =>
	useRequiredContext(ToggleListLocationContext, {
		providerName: "ToggleListLocation(Content|Trigger)",
	});
